import { getPocketBase, escFilter as esc } from '../pocketbase.js';

// --- liste giocatori ---
export async function savePlayerList({ accessKey, playerListData }, pbOverride) {
  const pb = pbOverride || getPocketBase();
  const data = { access_key: accessKey, player_list_data: playerListData, updated_at: new Date().toISOString() };
  const existing = await pb.collection('user_player_lists').getFullList({ filter: `access_key="${esc(accessKey)}"` });
  if (existing.length) return pb.collection('user_player_lists').update(existing[0].id, data);
  return pb.collection('user_player_lists').create(data);
}
export async function loadPlayerList(accessKey, pbOverride) {
  const pb = pbOverride || getPocketBase();
  const rows = await pb.collection('user_player_lists').getFullList({ filter: `access_key="${esc(accessKey)}"`, sort: '-updated_at' });
  return rows[0] || null;
}

// --- icone tag ---
async function upsertTagIconRow(pb, row) {
  const data = {
    access_key: row.access_key,
    player_name: row.player_name,
    team_name: row.team_name,
    tag_icons: row.tag_icons,
    updated_at: new Date().toISOString(),
  };
  const f = `access_key="${esc(row.access_key)}" && player_name="${esc(row.player_name)}" && team_name="${esc(row.team_name)}"`;
  const ex = await pb.collection('user_tag_icons').getFullList({ filter: f });
  if (ex.length) await pb.collection('user_tag_icons').update(ex[0].id, data);
  else await pb.collection('user_tag_icons').create(data);
}

export async function saveTagIcons(rows, pbOverride) {
  const pb = pbOverride || getPocketBase();
  await Promise.all(rows.map((row) => upsertTagIconRow(pb, row)));
  return { upserted: rows.length };
}
export async function loadTagIcons(accessKey, pbOverride) {
  const pb = pbOverride || getPocketBase();
  return pb.collection('user_tag_icons').getFullList({ filter: `access_key="${esc(accessKey)}"` });
}
